import React from "react"
import '@westernunion/css/lang/wuds.en.css'
const LanguageEN = () => {
    return (
        <></>
      )
}
export default LanguageEN
